export const mockData = {
  company: {
    name: "Elektrotechnik Wegele",
    owner: "Alexander Wegele",
    title: "Staatlich geprüfter Elektrotechniker",
    location: "Reichling",
    heroSlogan: "Ihre Ideen unter Spannung",
    heroSubtitle: "Ihr zuverlässiger Elektrotechniker in Reichling – modern, sicher, nachhaltig"
  },
  contact: {
    address: "Wurzbergstraße 3, 86934 Reichling",
    phone: "0162 294 69 61",
    email: "office@elektrotechnik-wegele.de",
    instagram: "@elektrotechnik_wegele"
  },
  aboutUs: {
    description: "Als staatlich geprüfter Elektrotechniker stehe ich für höchste Qualität, Zuverlässigkeit und moderne Technik. Mit langjähriger Erfahrung und persönlicher Betreuung sorge ich dafür, dass Ihre elektrischen Anlagen sicher und effizient funktionieren.",
    values: [
      { title: "Zuverlässigkeit", description: "Termine werden eingehalten, Qualität wird geliefert" },
      { title: "Präzision", description: "Jede Installation erfolgt nach neuesten Standards" },
      { title: "Moderne Technik", description: "Einsatz neuester Technologien und Verfahren" },
      { title: "Persönliche Betreuung", description: "Direkter Ansprechpartner für all Ihre Fragen" }
    ]
  },
  services: [
    {
      category: "Elektroinstallationen",
      description: "Professionelle Elektroinstallationen für Alt- und Neubau nach aktuellen VDE-Normen",
      icon: "Zap",
      features: ["Neuinstallationen", "Sanierungen", "Erweiterungen", "VDE-konforme Ausführung"]
    },
    {
      category: "Zählerschränke & Unterverteilungen",
      description: "Moderne Zählerschränke und Unterverteilungen für optimale Stromverteilung",
      icon: "Grid3X3",
      features: ["HAK-Installation", "Unterverteilungen", "Modernisierung", "Normgerechte Ausführung"]
    },
    {
      category: "Photovoltaikanlagen & Batteriespeicher",
      description: "Nachhaltige Energielösungen mit Solaranlagen und innovativen Speichersystemen",
      icon: "Sun",
      features: ["PV-Anlagen", "Batteriespeicher", "Monitoring", "Förderungsberatung"]
    },
    {
      category: "E-Mobility (Wallboxen & Ladeinfrastruktur)",
      description: "Zukunftssichere Ladelösungen für Elektrofahrzeuge zu Hause und im Betrieb",
      icon: "Car",
      features: ["Wallbox-Installation", "Lastmanagement", "Förderung", "Intelligente Ladesteuerung"]
    },
    {
      category: "Wartung & E-Check",
      description: "Regelmäßige Wartung und Prüfung nach DGUV V3 und VDE-Normen für Ihre Sicherheit",
      icon: "Settings",
      features: ["E-Check", "DGUV V3 Prüfung", "Wartungsverträge", "Protokollerstellung"]
    }
  ],
  projects: [
    {
      title: "Neubau Einfamilienhaus",
      description: "Komplette Elektroinstallation inklusive individueller LED-Lichtplanung und indirekter Beleuchtung",
      image: "/images/ref-led-bogen.webp",
      category: "Neubau"
    },
    {
      title: "PV-Anlage Kölbl",
      description: "Photovoltaikanlage auf Aufdach-Montage – schlüsselfertige Installation inkl. Anmeldung und Inbetriebnahme",
      image: "/images/ref-pv-koelbl.webp",
      category: "Photovoltaik"
    },
    {
      title: "PV-Anlage Abenthum",
      description: "Photovoltaikanlage in Ost-West-Ausrichtung – maximale Energieausbeute über den ganzen Tag",
      image: "/images/ref-pv-abenthum.webp",
      category: "Photovoltaik"
    },
    {
      title: "Zählerschrank & Batteriespeicher",
      description: "Modernisierung des Zählerschranks mit Sigenergy Batteriespeicher für maximalen Eigenverbrauch",
      image: "/images/ref-sigenergy.webp",
      category: "Speicher & Zähler"
    },
    {
      title: "Sungrow Hybrid-System",
      description: "Sungrow Wechselrichter mit passendem Batteriespeicher und smarter Verbrauchssteuerung",
      image: "/images/ref-sungrow.webp",
      category: "Speicher & Zähler"
    },
    {
      title: "Mennekes Wallbox",
      description: "Installation einer Mennekes Wallbox inkl. Absicherung und Ladeoptimierung für die eigene Garage",
      image: "/images/ref-wallbox.webp",
      category: "E-Mobility"
    },
    {
      title: "SMA Sunny Tripower",
      description: "SMA Sunny Tripower Smart Energy Wechselrichter für eine effiziente Photovoltaik-Einspeisung",
      image: "/images/ref-sma.webp",
      category: "Photovoltaik"
    }
  ],
  testimonials: [
    {
      name: "Familie Müller",
      location: "Reichling",
      text: "Herr Wegele hat unsere komplette Elektroinstallation im Neubau durchgeführt. Professionell, zuverlässig und immer freundlich!",
      rating: 5
    },
    {
      name: "Firma Schmidt GmbH",
      location: "Landsberg",
      text: "Schnelle und kompetente Installation unserer neuen Wallboxen. Sehr zu empfehlen!",
      rating: 5
    }
  ],
  faq: [
    {
      question: "Wie lange dauert eine Wallbox-Installation?",
      answer: "Eine Standard-Wallbox-Installation dauert in der Regel 2-4 Stunden, abhängig von den örtlichen Gegebenheiten und der Entfernung zum Hausanschluss."
    },
    {
      question: "Gibt es Förderungen für Photovoltaikanlagen?",
      answer: "Ja, es gibt verschiedene Förderprogramme auf Bundes-, Landes- und kommunaler Ebene. Wir beraten Sie gerne über aktuelle Fördermöglichkeiten."
    },
    {
      question: "Was kostet ein E-Check?",
      answer: "Die Kosten für einen E-Check variieren je nach Größe und Art der Anlage. Gerne erstellen wir Ihnen ein individuelles Angebot."
    },
    {
      question: "Wie oft sollte eine Elektroanlage geprüft werden?",
      answer: "Gewerbliche Anlagen müssen nach DGUV V3 jährlich geprüft werden. Private Anlagen empfehlen wir alle 4 Jahre zu prüfen."
    },
    {
      question: "Was beeinflusst die Kosten einer Elektroinstallation im Neubau?",
      answer: "Die Kosten für eine Elektroinstallation hängen von verschiedenen Faktoren ab: Hausgröße, Anzahl der Steckdosen und Schalter, gewünschte Ausstattung und Smart Home Integration. Gerne erstellen wir Ihnen ein kostenloses und individuelles Angebot für Ihr Bauvorhaben in Reichling und Umgebung."
    },
    {
      question: "Welche Zählerschrank-Modernisierung ist in Bayern vorgeschrieben?",
      answer: "Digitale Stromzähler (Smart Meter) werden schrittweise zur Pflicht. Oft muss der Zählerschrank für moderne Messtechnik modernisiert werden. Als Elektrotechniker in Reichling führen wir HAK-Installationen und Zählerschrank-Modernisierungen nach aktuellen VDE-Normen und gesetzlichen Vorgaben durch."
    },
    {
      question: "Lohnt sich eine Photovoltaikanlage in Reichling noch?",
      answer: "Ja, definitiv! Auch ohne EEG-Förderung rentiert sich eine PV-Anlage durch hohen Eigenverbrauch und Stromkostenersparnis. Mit Batteriespeicher erreichen Sie eine hohe Autarkie. Wir beraten Sie gerne zu aktuellen Förderprogrammen und berechnen Ihre individuelle Rendite basierend auf Ihrem Stromverbrauch."
    }
  ]
};